<template>
  <div class="profile-page">
    <div>
      <div class="vip-desc-box">
        <div class="vip-desc">
          Would you like to share your uploaded video or photo with our community? 
          By allowing it to become a template, you can inspire creativity, 
          help others explore exciting possibilities, 
          and contribute to a richer experience for everyone. 
          Your shared content could play a key role in shaping our premium collection!
        </div>
      </div>
      <div class="disclaimer-btn">
        <div @click="declineClick" class="disclaimer-btn-decline">Decline</div>
        <div @click="allowClick" class="disclaimer-btn-allow">Allow</div>
      </div>
      <div class="disclaimer-footer">
        By selecting 'Allow', you accept our <span @click="returnNewLink" class="disclaimer-footer-link">disclaimer</span>.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "share",
  props: {
    header: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      
    };
  },
  async mounted() {
    
  },
  methods: {
    async declineClick(){
      this.$emit("declineClick");
    },
    
    async allowClick() {
      this.$emit("allowClick");
    },
    returnNewLink(){
      const { href } = this.$router.resolve({
        path: '/disclaimer'
      });
      this.logEvent('fw_home_disclaimer',{fw_module_name:'disclaimer',fw_page:'home'})
      window.open(href, '_blank');
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.profile-page {
  color: #ffffff;
}
.vip-desc-box {
  display: flex;
  justify-content: center;
  .vip-desc {
    color: #000000;
    font-family: 'Microsoft YaHei','PingFang SC';
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    font-variation-settings: "opsz" auto;
    width: 419px;
    word-break: keep-all;
  }
}
.disclaimer-btn{
  display: flex;
  align-items: center;
  height: 100px;
  justify-content: space-around;
  .disclaimer-btn-decline{
    width: 150px;
    height: 50px;
    border-radius: 10px;
    opacity: 1;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #4D52DE;
    cursor: pointer;
    color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Microsoft YaHei','PingFang SC';
    font-size: 20px;
    font-weight: 600;
  }
  .disclaimer-btn-allow{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 50px;
    border-radius: 10px;
    opacity: 1;
    background: #4D52DE;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Microsoft YaHei','PingFang SC';
    font-size: 20px;
    font-weight: 600;
  }
}
.disclaimer-footer{
  font-family: 'Microsoft YaHei','PingFang SC';
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #000000;
  text-align: center;
  .disclaimer-footer-link{
    color: #0256FF;
    cursor: pointer;
  }
}
</style>
